export default __webpack_public_path__ + "static/media/fpa20200.fa816751.png";